import * as Actions from "./constants";
const isEmpty = require("is-empty");
const initialState = {
  isAuth: false,
  token: "",
};

export default function authReducer(state = initialState, action) {
  switch (action.type) {
    case Actions.LOGIN:
      return {
        ...state,
      };
    case Actions.SET_CURRENT_USER:
      return {
        ...state,
        isAuth: !isEmpty(action.payload),
        token: action.payload.token,
      };
    case Actions.GET_LOGIN_ERRORS:
      return {
        ...state,
        error: action.payload,
      };
    case Actions.LOGOUT:
      return {
        ...state,
      };
    default:
      return state;
  }
}
